import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  NameableInterface,
  Uuid,
} from '@hidat/huijs-common';
import { ZonedDateTime } from '@js-joda/core';
import { ResourceConfig } from '@hidat/huijs-resource';
import { splixerFieldConfigs } from './splixer-fields.const';

export const ChannelConfig: ResourceConfig = new ResourceConfig('Channel')
  .addFields([
    splixerFieldConfigs.intId,
    splixerFieldConfigs.uid,
    splixerFieldConfigs.status,
    splixerFieldConfigs.name,
    splixerFieldConfigs.stationId,
    new FieldConfig('timezone'),
    new FieldConfig('playlistUrl'),
    new FieldConfig('importerKlass').setRequired(true),
    new FieldConfig('importerConfig', FieldDataTypes.HASH),
    new FieldConfig('repositoryId', FieldDataTypes.UID),
    new FieldConfig('storageKlass'),
    new FieldConfig('storageConfig', FieldDataTypes.HASH),
    new FieldConfig('importSchedule', FieldDataTypes.INTEGER),
    new FieldConfig('importHour', FieldDataTypes.INTEGER),
    new FieldConfig('importFileCounts'),
    new FieldConfig('startsAt', FieldDataTypes.DATETIME),
    new FieldConfig('lastSyncedAt', FieldDataTypes.DATETIME).setEditable(false),
    new FieldConfig('audioSyncedThrough', FieldDataTypes.DATETIME).setEditable(
      false,
    ),
    new FieldConfig('showsSyncedThrough', FieldDataTypes.DATETIME).setEditable(
      false,
    ),
    new FieldConfig('playsSyncedThrough', FieldDataTypes.DATETIME).setEditable(
      false,
    ),
    new FieldConfig(
      'segmentsSyncedThrough',
      FieldDataTypes.DATETIME,
    ).setEditable(false),
    new FieldConfig(
      'mixesGeneratedThrough',
      FieldDataTypes.DATETIME,
    ).setEditable(false),
  ])
  .setSorts({
    name: 'name',
  })
  .setDefaultSort('name');

// Importer configuration - this should all options, and only basic types (no serialization is done)
export interface ChannelImporterSettings {
  library_id: number;
  combos_only: boolean;
  save_last_show: boolean;
  min_duration: number;
}

export const ChannelImporterSettingsConfig = [
  new FieldConfig('library_id', FieldDataTypes.INTEGER),
  new FieldConfig('min_duration', FieldDataTypes.INTEGER),
  new FieldConfig('meta_channel_id', FieldDataTypes.INTEGER),
  new FieldConfig('combos_only', FieldDataTypes.BOOLEAN),
  new FieldConfig('save_last_show', FieldDataTypes.BOOLEAN),
];

export interface ChannelCloudfrontConfig {
  dist_url: string;
  signed_urls: boolean;
}

export interface ChannelS3Config {
  profile: string;
  region: string;
  bucket_name: string;
  path: string;
  signed_urls: boolean;
}

export interface ChannelFilesystemConfig {
  path: string;
}

export const StorageConfigKlass = {
  CloudFront: 'CloudFront',
  S3: 'S3',
  FileSystem: 'FileSystem',
};
export type StorageConfigKlasses =
  (typeof StorageConfigKlass)[keyof typeof StorageConfigKlass];

export enum ImportScheduleSettings {
  NotSchedule = 0,
  Hourly = 10,
  Daily = 20,
  Weekdays = 30,
  Weekends = 40,
}

export interface ChannelInterface
  extends SplixerResourceInterface<number>, NameableInterface {
  uid: Uuid | undefined;
  stationId: number | undefined;
  timezone: string | undefined;
  playlistUrl: string | undefined;

  importerKlass: string | undefined;
  importerConfig: AnyHash | undefined;
  repositoryId: Uuid | undefined; // Replacing storage klass/config in the Typescript land....
  storageKlass: StorageConfigKlasses | undefined;
  storageConfig: AnyHash | undefined;

  startsAt: ZonedDateTime | undefined;
  lastSyncedAt: ZonedDateTime | undefined;
  audioSyncedThrough: ZonedDateTime | undefined;
  playsSyncedThrough: ZonedDateTime | undefined;
  showsSyncedThrough: ZonedDateTime | undefined;
  segmentsSyncedThrough: ZonedDateTime | undefined; //sb segmentsGeneratedThrough
  mixesGeneratedThrough: ZonedDateTime | undefined;
  importSchedule: ImportScheduleSettings | undefined;
  importHour: number | undefined;
  importFileCounts: string | undefined;

  tenantId: string | undefined;
}

export interface ChannelIngestParams {
  startDate: ZonedDateTime | undefined;
  endDate?: ZonedDateTime;
  overwrite: boolean;
}
